import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

// Import and register all controllers from this directory
import WizardController from "./wizard_controller"
import PolicyContentController from "./policy_content_controller"
import CvdTimelineController from "./cvd_timeline_controller"
import InlineFormController from "./inline_form_controller"
import CustomDomainController from "./custom_domain_controller"
import ClipboardController from "./clipboard_controller"
import ImageUploadController from "./image_upload_controller"
import TunnelSelectController from "./tunnel_select_controller"
import BulkSelectController from "./bulk_select_controller"
import EncryptionController from "./encryption_controller"
import DrawerActionController from "./drawer_action_controller"
import DashboardChartController from "./dashboard_chart_controller"
import DrawerLoadController from "./drawer_load_controller"
import ColumnPickerController from "./column_picker_controller"
import ExpandableRowController from "./expandable_row_controller"
import FeatureIntroController from "./feature_intro_controller"
import TabsController from "./tabs_controller"
import CollapsibleController from "./collapsible_controller"
import MaturityGraphController from "./maturity_graph_controller"
import MaturityActivityController from "./maturity_activity_controller"
import ToggleController from "./toggle_controller"
import GroupsConfigController from "./groups_config_controller"
import ConfirmDangerousActionController from "./confirm_dangerous_action_controller"
import VerificationController from "./verification_controller"
import AttestationController from "./attestation_controller"
import FragmentSecretController from "./fragment_secret_controller"
import DnsCheckController from "./dns_check_controller"
import DomainVerificationChannelController from "./domain_verification_channel_controller"
import ResearchThreatsSyncController from "./research_threats_sync_controller"
import PlatformsSyncController from "./platforms_sync_controller"
import OrgSearchController from "./org_search_controller"
import PlanIntervalController from "./plan_interval_controller"
import WorkflowEditorController from "./workflow_editor_controller"
import WorkflowDrawingController from "./workflow_drawing_controller"
import FilterConditionsController from "./filter_conditions_controller"
import BriefIntakeOptionsController from "./brief_intake_options_controller"

application.register("wizard", WizardController)
application.register("policy-content", PolicyContentController)
application.register("cvd-timeline", CvdTimelineController)
application.register("inline-form", InlineFormController)
application.register("custom-domain", CustomDomainController)
application.register("clipboard", ClipboardController)
application.register("image-upload", ImageUploadController)
application.register("tunnel-select", TunnelSelectController)
application.register("bulk-select", BulkSelectController)
application.register("encryption", EncryptionController)
application.register("drawer-action", DrawerActionController)
application.register("dashboard-chart", DashboardChartController)
application.register("drawer-load", DrawerLoadController)
application.register("column-picker", ColumnPickerController)
application.register("expandable-row", ExpandableRowController)
application.register("feature-intro", FeatureIntroController)
application.register("tabs", TabsController)
application.register("collapsible", CollapsibleController)
application.register("maturity-graph", MaturityGraphController)
application.register("maturity-activity", MaturityActivityController)
application.register("toggle", ToggleController)
application.register("groups-config", GroupsConfigController)
application.register("confirm-dangerous-action", ConfirmDangerousActionController)
application.register("verification", VerificationController)
application.register("attestation", AttestationController)
application.register("fragment-secret", FragmentSecretController)
application.register("dns-check", DnsCheckController)
application.register("domain-verification-channel", DomainVerificationChannelController)
application.register("research-threats-sync", ResearchThreatsSyncController)
application.register("platforms-sync", PlatformsSyncController)
application.register("org-search", OrgSearchController)
application.register("plan-interval", PlanIntervalController)
application.register("workflow-editor", WorkflowEditorController)
application.register("workflow-drawing", WorkflowDrawingController)
application.register("filter-conditions", FilterConditionsController)
application.register("brief-intake-options", BriefIntakeOptionsController)

export { application }
